/**
 * Mask email for display: show first and last char of local part, mask the rest.
 * e.g. "idisrock0@gmail.com" → "i*******0@gmail.com"
 * Admin users see the full email.
 */
export function maskEmail(email: string, isAdmin = false): string {
  if (!email) return '';
  if (isAdmin) return email;
  const [local, domain] = email.split('@');
  if (!domain) return email;
  if (local.length <= 2) return `${local[0]}*@${domain}`;
  return `${local[0]}${'*'.repeat(local.length - 2)}${local[local.length - 1]}@${domain}`;
}
